import api from './api';

export const checkoutService = {
  createOrder: async (addressId, deliveryPartner, deliveryPartnerTat, shippingCost, couponReservationId) => {
    const body = {
      addressId,
      deliveryPartner,
      deliveryPartnerTat,
      shippingCost,
    };
    if (couponReservationId) {
      body.couponReservationId = couponReservationId;
    }
    const response = await api.post('/checkout/create-order', body);
    return response.data;
  },

  verifyPayment: async (razorpayOrderId, razorpayPaymentId, razorpaySignature) => {
    const response = await api.post('/checkout/verify-payment', {
      razorpayOrderId,
      razorpayPaymentId,
      razorpaySignature
    });
    return response.data;
  },

  getMyOrders: async () => {
    const response = await api.get('/checkout/my-orders');
    return response.data;
  }
};

export default checkoutService;
